export const getPaymentModeList = state => {
    return state.list
}

export const getPaymentModeDataProps = state => {
    return state.props
}


// WEBPACK FOOTER //
// ./src/store/modules/paymentMode/getters.js